import * as api from './api';
import { GroupIndexingRule } from './models';
import * as MutationTypes from './mutationTypes';

export const groupIndexingRuleListRequest = async ({ commit, getters: { groupIndexingRuleList } }, pointOfSaleGuid) => {
  if (groupIndexingRuleList.length === 0) {
    const response = await api.groupIndexingRuleListRequest(pointOfSaleGuid);
    const rules = GroupIndexingRule.toInstanceList(response.data.results);
    commit(MutationTypes.GROUP_INDEXING_RULE_LIST_SUCCESS, rules);
  }
};

export const createGroupIndexingRuleRequest = async ({ commit }, ruleToCreate) => {
  const response = await api.createGroupIndexingRuleRequest(ruleToCreate.serialize());
  const ruleCreated = GroupIndexingRule.toInstance(response.data);
  commit(MutationTypes.CREATE_GROUP_INDEXING_RULE_SUCCESS, ruleCreated);
};

export const updateGroupIndexingRuleRequest = async ({ commit }, ruleToUpdate) => {
  await api.updateGroupIndexingRuleRequest(ruleToUpdate.serialize());
  commit(MutationTypes.UPDATE_GROUP_INDEXING_RULE_SUCCESS, ruleToUpdate);
};

export const removeGroupIndexingRuleRequest = async ({ commit }, ruleGuidToDelete) => {
  await api.removeGroupIndexingRuleRequest(ruleGuidToDelete);
  commit(MutationTypes.REMOVE_GROUP_INDEXING_RULE_SUCCESS, ruleGuidToDelete);
};
